import { Badge } from "../components/ui/badge";
import { Card, CardContent } from "../components/ui/card";
import { Star } from "lucide-react";

const Reviews = () => {
  const reviews = [
    {
      name: "Sarah Johnson",
      location: "Austin, TX",
      rating: 5,
      review: "PASAT COMPANY exceeded our expectations! The installation was professional, clean, and completed on time. Our energy bills have dropped by 85% since installing the solar panels.",
      savings: "$2,400/year"
    },
    {
      name: "Michael Chen", 
      location: "Phoenix, AZ",
      rating: 5,
      review: "Outstanding service from start to finish. The team was knowledgeable, answered all our questions, and the solar system has been performing flawlessly for 2 years now.",
      savings: "$3,200/year"
    },
    {
      name: "Emily Rodriguez",
      location: "San Diego, CA", 
      rating: 5,
      review: "We're thrilled with our solar installation! The quality of work is exceptional, and the monitoring app helps us track our energy production daily. Highly recommend!",
      savings: "$2,800/year"
    },
    {
      name: "David Thompson",
      location: "Denver, CO",
      rating: 5,
      review: "From consultation to installation, everything was handled professionally. The solar panels look great on our roof and we're saving money every month. Great investment!",
      savings: "$2,100/year"
    },
    {
      name: "Lisa Wang",
      location: "Las Vegas, NV",
      rating: 5,
      review: "PASAT COMPANY made going solar simple and stress-free. The team guided us through every step and the installation quality is top-notch. Our neighbors are asking for referrals!",
      savings: "$3,500/year"
    },
    {
      name: "Robert Miller",
      location: "Tampa, FL",
      rating: 5,
      review: "Amazing experience! The solar panels have been producing more energy than expected. The customer service team is responsive and the warranty gives us peace of mind.",
      savings: "$2,600/year"
    }
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star key={i} className={`h-4 w-4 ${i < rating ? 'fill-solar-yellow text-solar-yellow' : 'text-muted-foreground'}`} />
    ));
  };

  return (
    <section id="reviews" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Badge variant="outline" className="mb-4 border-secondary text-secondary">
            Customer Reviews
          </Badge>
          <h2 className="text-4xl lg:text-5xl font-bold mb-6 bg-gradient-solar bg-clip-text text-transparent">
            What Our Customers Say
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Don't just take our word for it. Here's what real customers say about their experience with PASAT COMPANY.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {reviews.map((review, index) => (
            <Card key={index} className="border-0 shadow-card-solar hover:shadow-solar transition-all duration-300 hover:-translate-y-1">
              <CardContent className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex space-x-1">
                    {renderStars(review.rating)}
                  </div>
                  <Badge variant="outline" className="border-solar-green text-solar-green">
                    Saves {review.savings}
                  </Badge>
                </div>
                
                <p className="text-muted-foreground mb-6 leading-relaxed italic">
                  "{review.review}"
                </p>
                
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-gradient-solar rounded-full flex items-center justify-center mr-4">
                    <span className="text-primary-foreground font-bold">
                      {review.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <h4 className="font-bold text-primary">{review.name}</h4>
                    <p className="text-sm text-muted-foreground">{review.location}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Card className="inline-block border-0 shadow-card-solar bg-gradient-to-r from-solar-light-blue to-background">
            <CardContent className="p-8">
              <div className="flex items-center justify-center gap-8 text-center">
                <div>
                  <div className="text-4xl font-bold text-primary mb-2">4.9/5</div>
                  <div className="flex justify-center space-x-1 mb-2">
                    {renderStars(5)}
                  </div>
                  <p className="text-muted-foreground">Average Rating</p>
                </div>
                <div className="w-px h-16 bg-border"></div>
                <div>
                  <div className="text-4xl font-bold text-primary mb-2">1,200+</div>
                  <p className="text-muted-foreground">Happy Customers</p>
                </div>
                <div className="w-px h-16 bg-border"></div>
                <div>
                  <div className="text-4xl font-bold text-primary mb-2">98%</div>
                  <p className="text-muted-foreground">Satisfaction Rate</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Reviews;